<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div class="row pl-4 pr-4" v-show="tela == 1">
            <h4 slot="header" class="card-title text-left m-0">
              RELATÓRIO DE FALTAS
            </h4>
            <BaseFiltroRelatorio
              class="col-sm-6 col-12"
              :filterBancoHora="false"
              :limitarData="true"
              @pesquisar="pesquisar"
              :btEnviarEmail="false"
            />
            <div class="offset-sm-6 "></div>
          </div>

          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>

            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      {{ `RELATÓRIO DE FALTAS` }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `PERÍODO: ${moment(payloadPesquisa.data_inicial).format(
                          "DD/MM/YYYY",
                        )} à
                      ${moment(payloadPesquisa.data_final).format(
                        "DD/MM/YYYY",
                      )}`
                      }}
                    </div>
                  </div>

                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `DEPARTAMENTO: ${
                          payloadPesquisa.departamento
                            ? payloadPesquisa.departamento.descricao
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `DEPARTAMENTO: NENHUM` }}
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col text-left"
                      v-if="!payloadPesquisa.id_funcionario"
                    >
                      {{
                        `POSTO DE TRABALHO: ${
                          payloadPesquisa.posto
                            ? payloadPesquisa.posto.local
                            : "TODOS"
                        }`
                      }}
                    </div>
                    <div class="col text-left" v-else>
                      {{ `POSTO DE TRABALHO: NENHUM` }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabela de Resultados-->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">Total de Faltas</th>
                    <th scope="col">Dias</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dados" :key="item.empregado">
                    <th>
                      <p class="m-0 p-0">{{ item.empregado || `` }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.faltasDias || 0 }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ pegarDias(item.datasFaltas) }}</p>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <Paginacao
              v-show="!printing"
              :currentPage="pagination.currentPage"
              :totalPages="pagination.totalPages"
              @page-changed="listarRelatorioFalta"
            />
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseInput,
  BaseFiltroRelatorio,
  Paginacao,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroRelatorio,
    Paginacao,
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        perPage: 50,
        totalItems: 0,
        totalPages: 0,
      },
      payloadPesquisa: Object,
      printing: false,
      isLoading: false,
      tela: 1, //1 filtros, 2 -resultados
      dados: [],
    };
  },
  methods: {
    pegarDias(item) {
      return item
        .map((el) => this.moment(el).format("D"))
        .sort((a, b) => a - b)
        .join(", ");
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    listarRelatorioFalta(page = 1) {
      let th = this;
      th.isLoading = true;
      const bodyFormData = {
        ...this.payloadPesquisa,
        page,
        limit: this.pagination.perPage,
      };
      this.axios
        .post("/api/relatorio/listarRelatorioFalta", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.dados = response.data.data.funcionarios;
            th.pagination = response.data.data.paginacao;
            th.tela = 2;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar relatório!",
            "error",
          );
        });
    },
    pesquisar(event) {
      this.payloadPesquisa = event;
      this.listarRelatorioFalta(1);
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
  },
};
</script>
<style></style>
